export default __webpack_public_path__ + "static/media/Android-Logo-green.2a9ae550.png";